function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import styled from 'styled-components';
import { Section } from '../../Section';
import { Carousel, breakPointsSet4 } from '../../Carousel';
import { SkeletonSquare } from '../../Skeleton';
import { ContentProductCard, LastProductCard } from '../ContentProductCard';
var sizes = {
  large: {
    width: 300,
    height: 530
  },
  cta: {
    width: 260,
    height: 530
  }
};
export var SkeletonCard = styled.div.withConfig({
  displayName: "ContentProductsCarousel__SkeletonCard",
  componentId: "sc-a31eh7-0"
})(["margin-top:30px;height:445px;"]);
export var ContentProductsCarousel = function ContentProductsCarousel(_ref) {
  var fetching = _ref.fetching,
    title = _ref.title,
    subtitle = _ref.subtitle,
    products = _ref.products,
    _ref$subscriptions = _ref.subscriptions,
    subscriptions = _ref$subscriptions === void 0 ? [] : _ref$subscriptions,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'large' : _ref$variant,
    tag = _ref.tag,
    _ref$onFollow = _ref.onFollow,
    onFollow = _ref$onFollow === void 0 ? null : _ref$onFollow,
    _ref$onAction = _ref.onAction,
    onAction = _ref$onAction === void 0 ? null : _ref$onAction,
    link = _ref.link,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    _ref$viewMore = _ref.viewMore,
    viewMore = _ref$viewMore === void 0 ? null : _ref$viewMore,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? [] : _ref$context,
    _ref$distributorsWhit = _ref.distributorsWhiteList,
    distributorsWhiteList = _ref$distributorsWhit === void 0 ? [] : _ref$distributorsWhit;
  var aditionalProps = {};
  if (sizes.hasOwnProperty(variant)) aditionalProps.itemWidth = sizes[variant].width;
  return React.createElement(Section, {
    title: title || null,
    subtitle: subtitle || null,
    link: link,
    bottomMargin: bottomMargin
  }, fetching || !products.length ? React.createElement(Carousel, _extends({
    breakpoints: breakPointsSet4
  }, aditionalProps), [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function (placeholderId) {
    return React.createElement(SkeletonCard, {
      key: placeholderId
    }, React.createElement(SkeletonSquare, {
      style: {
        height: '100%'
      }
    }));
  })) : React.createElement(Carousel, _extends({
    breakpoints: breakPointsSet4
  }, aditionalProps), [].concat(_toConsumableArray(products.map(function (product, index) {
    var prod = !product.hasOwnProperty('entity') ? _objectSpread(_objectSpread({}, product), {}, {
      entity: product
    }) : product;
    return React.createElement(ContentProductCard, {
      key: index,
      position: index,
      product: prod,
      variant: variant,
      tag: tag || null,
      following: subscriptions.includes(prod.entity.id),
      onFollow: onFollow,
      onAction: onAction ? function () {
        return onAction(prod);
      } : null,
      withSPA: withSPA,
      context: context,
      distributorsWhiteList: distributorsWhiteList
    });
  })), _toConsumableArray(viewMore ? [React.createElement(LastProductCard, {
    key: products.length + 1,
    variant: variant,
    viewMore: viewMore
  })] : []))));
};